import React from 'react';
import UploadButton from '../UploadButton';
import SelectField from '../../../forms/SelectField';
import TextArea from '../../../forms/TextArea';
import { CONTRACT_UPLOAD_STATES } from '../../../../constants/settings';

const ContractUploadFields = ({ onInput, data }) => (
    <React.Fragment>
        <SelectField
            onChange={onInput}
            withSearch={false}
            items={CONTRACT_UPLOAD_STATES}
            label="State"
            name="state"
            value={data.state}
        />
        <UploadButton
            accept="application/pdf"
            className="u-margin-bottom-3"
            name="file"
            onChange={onInput}
            value={data.file}
            maxSize={20}
        />
        <TextArea
            onChange={onInput}
            name="comments"
            value={data.comments}
            label="Comments"
            placeholder="Leave an optional comment for the signers..."
        />
    </React.Fragment>
);

export default ContractUploadFields;
